import { useEffect, useState, useRef } from 'react'
import styled from 'styled-components'
import Bg from 'assets/img/screenType1/00-bg.png'
import Icon1 from 'assets/img/screenType1/prun_icon1.png'
import Icon2 from 'assets/img/screenType1/prun_icon2.png'
import Icon3 from 'assets/img/screenType1/prun_icon3.png'
import Icon4 from 'assets/img/screenType1/prun_icon4.png'
import Icon5 from 'assets/img/screenType1/prun_icon5.png'

import { selectDevice } from 'hooks/deviceInfo'
import { useSelector } from 'react-redux'

import { animated, useSprings, useTrail, config } from '@react-spring/web'

import { useNavigate, useSearchParams } from 'react-router-dom'
import BtnPopupClose from 'assets/img/common/PopupCloseBtn.png'
import PrunTopLogo from 'assets/img/screenType1/prun_top_logo.png'

const Container = styled.div`
	position: relative;
	width: 1920px;
	height: 1080px;
	background-image: url(${Bg});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	.btnMenuClose {
		position: absolute;
		top: 120px;
		right: 23px;
		width: 75px;
		height: 75px;
		border: 0;
		outline: 0;
		background: url(${BtnPopupClose}) no-repeat;
		z-index: 10;
		box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
		cursor: pointer;
		border-radius: 50%;
		display: none;
		&.active {
			display: block;
		}
	}
`
const Menu = styled.ul`
	list-style: none;
	display: flex;
	justify-content: space-around;
	position: absolute;
	bottom: 160px;
	left: 75px;
	right: 75px;
	overflow: hidden;
	transition: all 0.3s ease;
	li {
		border-radius: 15px;
		width: 320px;
		height: 500px;
		position: relative;
	}
`

const MenuItem = styled(animated.div)`
	width: 100%;
	height: 100%;
	position: absolute;
	inset: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	backface-visibility: hidden;
`

const TochTheScreen = styled.div`
	position: absolute;
	left: 70px;
	top: 400px;
	color: #001f66;
`

// IframeContainer는 iframe을 감싸는 컨테이너로, 팝업 닫기 버튼과 iframe을 포함한다.
const IframeContainer = styled.div`
	position: absolute;
	top: -100px;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1000;
	display: flex;
	justify-content: center;
	align-items: center;
	.btnPopupClose {
		position: absolute;
		top: 120px;
		right: 23px;
		width: 75px;
		height: 75px;
		border: 0;
		outline: 0;
		background: url(${BtnPopupClose}) no-repeat;
		z-index: 10000;
		box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
		cursor: pointer;
		border-radius: 50%;
	}
	visibility: hidden;
	transition: all 0.5s ease;
	opacity: 0;
	&.active {
		top: 0;
		opacity: 1;
		visibility: visible;
	}
`

// Iframe는 실제로 iframe을 렌더링하는 컴포넌트로, 전체 크기를 차지하며 테두리가 없다.
const Iframe = styled.iframe`
	width: 100%;
	height: 100%;
	border: none;
`

const PrunMain = styled.div`
	position: absolute;
	bottom: -100px;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1000;
	background: #eeedec;
	visibility: hidden;
	transition: all 0.5s ease;
	opacity: 0;
	font-family: 'asics bold italic';
	&.active {
		visibility: visible;
		opacity: 1;
		bottom: 0;
	}
`
//흰배경 : 로고+애니메이션 글자
const PrunMainTop = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 30px;
	background: #fff;
`
//메인기능 : 가로정렬 + 높이 주기
const PrunMainBottom = styled.div`
	display: flex;
	height: calc(1080px - 112px);
`
//메인기능 : 버튼+글자
const MainButton = styled.div`
	background: #eeedec;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 50%;
	color: #565858;
	text-align: center;
	button {
		background: #d8d8d8;
		box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
		font-size: 48px;
		padding: 50px;
		border-radius: 100px;
		width: 700px;
		height: 150px;
		font-weight: bold;
		color: #565858;
		border: none;
		font-family: 'asics bold italic';
	}
	h2 {
		font-size: 36px;
		margin-top: 50px;
	}
	p {
		font-size: 24px;
		margin-top: 10px;
	}
`

/**
 * P.RUN 러닝화 선택 화면
 * @param param0
 * @returns
 */
const ScreenType1 = ({ menuList }: any) => {
	const [params] = useSearchParams()
	const deviceInfo = useSelector(selectDevice)
	const navigate = useNavigate()

	const [isHideMain, setIsHideMain] = useState<boolean>(true)
	const [isShowIframe, setIsShowIframe] = useState<boolean>(false)

	const [trail, api] = useTrail(menuList.length, () => ({
		rotateX: 0,
	}))

	const [rand, setRand] = useState<number>(0)

	const isFlipped = useRef(false)

	const onItemClick = (item: any) => {
		console.log(item)
		switch (item.title) {
			case '쿠션화':
				navigate('/prun/cushion', {
					state: { item, kioskDeviceId: deviceInfo.kioskDeviceId },
				})
				break
			case '안정화':
				navigate('/prun/protection', {
					state: { item, kioskDeviceId: deviceInfo.kioskDeviceId },
				})
				break
			case '바운싱화':
				navigate('/prun/bounce', {
					state: { item, kioskDeviceId: deviceInfo.kioskDeviceId },
				})
				break
			case '레이싱화':
				navigate('/prun/speed', {
					state: { item, kioskDeviceId: deviceInfo.kioskDeviceId },
				})
				break
			case '트레일러닝화':
				navigate('/prun/trail', {
					state: { item, kioskDeviceId: deviceInfo.kioskDeviceId },
				})
				break
			default:
				break
		}
	}

	useEffect(() => {
		console.log(menuList)
		console.log(params.get('showIframe'))
		if (params.get('showIframe') === 'true') {
			setIsShowIframe(true)
			setIsHideMain(false)
		}
		if (deviceInfo.branchCd && deviceInfo.kioskName) {
			setTimeout(() => {
				if (isFlipped.current) {
					api.start({
						rotateX: 0,
					})
					isFlipped.current = false
				} else {
					api.start({
						rotateX: 360,
					})
					isFlipped.current = true
				}
				// setRand(Math.random())
			}, 5000)
		}
		const disablePinchZoom = (e: any) => {
			if (e.touches.length > 1) {
				e.preventDefault()
			}
		}
		document.addEventListener('touchmove', disablePinchZoom, {
			passive: false,
		})
		return () => {
			document.removeEventListener('touchmove', disablePinchZoom)
		}
	}, [rand])

	// 에니메이션 텍스트
	const text = 'Touch the screen'.split('')

	// 각 글자마다 애니메이션 상태 생성
	// const [springs] = useSprings(text.length, (i) => ({
	//     from: { transform: 'translateY(0px)' },
	//     to: { transform: 'translateY(-10px)' },
	//     config: config.wobbly,
	//     delay: i * 50,
	//     loop: { reverse: true },
	// }))
	const [springs] = useSprings(text.length, (i) => ({
		from: { opacity: 0 },
		to: { opacity: 1 },
		loop: { reverse: true },
	}))

	return (
		<Container>
			{/* <button
				type="button"
				className={!isHideMain ? 'btnMenuClose active' : 'btnMenuClose'}
				onClick={() => {
					setIsShowIframe(false)
					setIsHideMain(true)
				}}
			></button> */}
			{/* isShowIframe 변수값이 true로 두면 iframe이 출력되고, false로 두면 신규 화면이 출력된다. */}
			{/* <IframeContainer className={isShowIframe ? 'active' : ''}>
				<button
					type="button"
					className="btnPopupClose"
					onClick={() => {
						setIsShowIframe(false)
						setIsHideMain(true)
					}}
				></button>
				<Iframe
					src={`https://ak.app-spot2.co.kr/ko/comparison-lang.html`}
					title="글로벌사이트"
				></Iframe>
			</IframeContainer> */}
			{/* isHideMain 변수값을 false로 두면 신규 화면이 출력되고, true로 두면 러닝화 선택버튼 5개가 출력된다. <PrunMain className={isHideMain ? 'active' : ''}> */}
			<PrunMain>
				<PrunMainTop>
					<img
						src={PrunTopLogo}
						alt="asics logo"
					/>
					<div
						style={{
							display: 'flex',
							fontSize: '32px',
							fontWeight: 'lighter',
							color: '#001f66',
							fontFamily: 'asics regular',
						}}
					>
						{springs.map((style, i) => (
							<animated.span
								key={i}
								style={{
									...style,
									marginRight: 2,
									display: 'inline-block',
								}}
							>
								{text[i] === ' ' ? '\u00A0' : text[i]}
							</animated.span>
						))}
					</div>
				</PrunMainTop>
				<PrunMainBottom>
					<MainButton
						style={{
							backgroundColor: '#d8d8d8',
						}}
					>
						<div>
							{/* 버튼은 폰트 사이즈 48px 색상은 #565858 */}
							<button
								type="button"
								onClick={() => {
									setIsHideMain(false)
								}}
							>
								PRODUCT FINDER
							</button>

							{/* 이거는 폰트 사이즈 36px 색상은 #565858 */}
							<h2>기능별 러닝화 찾기</h2>

							{/* 이거는 폰트 사이즈 24px 색상은 #565858 */}
							<p>나에게 맞는 러닝화를 기능별로 찾아보세요.</p>
						</div>
					</MainButton>
					<MainButton>
						<div>
							{/* 버튼은 폰트 사이즈 48px 색상은 #565858 */}
							<button
								type="button"
								style={{ backgroundColor: '#eeedec' }}
								onClick={() => {
									setIsShowIframe(true)
									setIsHideMain(false)
								}}
							>
								PRODUCT COMPARISON
							</button>
							{/* 이거는 폰트 사이즈 36px 색상은 #565858 */}
							<h2>러닝화 비교하기</h2>
							{/* 이거는 폰트 사이즈 24px 색상은 #565858 */}
							<p>두가지 러닝화를 한눈에 비교해 보세요.</p>
						</div>
					</MainButton>
				</PrunMainBottom>
			</PrunMain>
			<TochTheScreen>
				<div
					style={{
						display: 'flex',
						fontSize: '50px',
						fontWeight: 'normal',
					}}
				>
					{springs.map((style, i) => (
						<animated.span
							key={i}
							style={{
								...style,
								marginRight: 2,
								display: 'inline-block',
							}}
						>
							{text[i] === ' ' ? '\u00A0' : text[i]}
						</animated.span>
					))}
				</div>
			</TochTheScreen>
			<Menu className={isHideMain ? '' : 'active'}>
				{menuList.map((item: any, index: number) => {
					return (
						<li
							key={index}
							onClick={() => onItemClick(item)}
						>
							<MenuItem style={{}}>
								{item.title === '안정화' && (
									<img
										src={Icon1}
										alt={item.title}
									/>
								)}
								{item.title === '쿠션화' && (
									<img
										src={Icon2}
										alt={item.title}
									/>
								)}
								{item.title === '바운싱화' && (
									<img
										src={Icon3}
										alt={item.title}
									/>
								)}
								{item.title === '레이싱화' && (
									<img
										src={Icon4}
										alt={item.title}
									/>
								)}
								{item.title === '트레일러닝화' && (
									<img
										src={Icon5}
										alt={item.title}
									/>
								)}
								{/* <img
                                    src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
                                    alt={item.title}
                                    style={{ width: 330 }}
                                    loading="lazy"
                                /> */}
							</MenuItem>
						</li>
					)
				})}
			</Menu>
		</Container>
	)
}

export default ScreenType1
